import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { CDropdown, CDropdownItem, CDropdownMenu } from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getNotifications, hideMessage } from '../redux/actions/notifications';
import { setToast } from '../redux/actions/window';
import LoadingAvatar from '../components/LoadingAvatar';

import moment from 'moment';
import i18next from 'i18next';

import { useTranslation } from 'react-i18next';
import { LOADING_BLUE } from '../utils/colorCode';
import { isEmpty } from 'lodash';

import { Link, useHistory, useLocation } from 'react-router-dom';
import { Fonts, Palette } from '../components/utils';
import { FaBell, FaAngleRight } from 'react-icons/fa';
import { IoMdSettings } from 'react-icons/io';
import { HeaderNavButton, HeaderNavButtonIcon, HeaderNavButtonIconBadge } from './HeaderComponents';
import { getNotificationIcon, handleLinkNotification, modifyNotificationText } from '../helper';
import { NEW_NOTIFICATION_KEY, NOTIFICATION_TYPES, isLeakDetectorNotification } from '../helper/constants';
import { useGetWLDConfigs } from '../hooks/useGetWLDConfigs';
import { ImageContainer, StyledImage } from '../views/settings/SettingsImages';
import { safeJsonParse } from '../utils/utils';
import { requestFail, requestSuccess } from '../utils/status';
import { GET_NOTIFICATIONS, REGISTER_FCM_TOKEN } from '../redux/constants';
import { ErrorText } from '../components/utils/AvatarCropper';

const TheHeaderDropdownMssg = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { receivedNotification, status, notifications } = useSelector(
    (state) => state.notification
  );
  
  const newNotification = localStorage.getItem(NEW_NOTIFICATION_KEY) || '';

  const { profile } = useSelector((state) => state.profile);
  const { shouldShowLeakDetectors } = useGetWLDConfigs();

  const [filteredNotifications, setFilteredNotifications] = useState([]);

  const notificationMenuRef = useRef(null);

  moment.locale(i18next.resolvedLanguage);

  const dispatch = useDispatch();
  const unread = true;
  useEffect(() => {
    if (Object.keys(receivedNotification).length) {
      dispatch(
        setToast({
          toastShow: true,
          toastMessage: receivedNotification.body,
          notificationHeader: receivedNotification.title,
          modal: 'notification'
        })
      );
    }
    dispatch(getNotifications());
  }, [receivedNotification, dispatch]);

  useEffect(() => {
    if (notifications?.length > 0 && !isEmpty(profile))
      setFilteredNotifications(
        notifications?.filter((notif) =>
          moment(notif?.create_date).isSameOrAfter(profile?.create_date)
        )
      );
  }, [notifications, profile]);

  const handleClickNotification = (notif) => {
    if (isLeakDetectorNotification(notif.type_id)) {
      handleLinkNotification(notif, () => history.push('/leak-detectors'));
    } else {
      handleLinkNotification(notif);
    }
  };

  const handleClickNotificationMenuButton = () => {
    if (notificationMenuRef.current) {
      const menuIsOpen = notificationMenuRef.current.getAttribute('aria-hidden') === 'true';
      if (menuIsOpen) {
        dispatch(getNotifications());
        // Clear notification badge if it exists
        if (newNotification && safeJsonParse(newNotification)?.title) {
          dispatch(hideMessage());
        }
      }
    }
  }

  const NotificationsList = ({ data }) => {
    return data.length > 0 ? (
      <NotificationDiv>
        {data.map((notif, index) => (
          <StyledCDropdownItem
            onClick={() => handleClickNotification(notif)}
            key={index}
            href="#"
            className={unread ? 'unread border-bottom' : 'border-bottom'}>
            <StyledMessageContainer>
              {/* <GrataIconNotif className="messageImage" /> */}
              <ImageContainer className="messageImage">
                <StyledImage src={getNotificationIcon(notif.type_id)} />
              </ImageContainer>
              <div className="messageColumn">
                <span className="messageDesc">{modifyNotificationText(notif.content, notif.type_id)}</span>
                <span className="messageDate">
                  {notif.create_date && moment(notif.create_date).format('M/D/YYYY [at] h:mm A')}
                </span>
              </div>
              <FaAngleRight className="arrowIcon" />
            </StyledMessageContainer>
          </StyledCDropdownItem>
        ))}
      </NotificationDiv>
    ) : (
      <EmptyNotificationContainer>
        <p className="empty-notification-text">{'No new notifications'}</p>
      </EmptyNotificationContainer>
    );
  };

  return (
    <StyledCDropdown inNav className="c-header-nav-item mx-2" direction="down">
      <HeaderNavButton caret={false} onClick={handleClickNotificationMenuButton}>
        <HeaderNavButtonIcon>
          <FaBell size={25} style={{ zIndex: 4 }} />
        </HeaderNavButtonIcon>
        {receivedNotification?.title ||
          (newNotification && safeJsonParse(newNotification)?.title && (
            <HeaderNavButtonIconBadge />
          ))}
      </HeaderNavButton>

      <CDropdownMenu className="pt-0" placement="bottom-end" innerRef={(el) => {notificationMenuRef.current = el}}>
        <StyledHeaderCDropdownItem>
          <p className="title">{t('Notifications')}</p>
          <div className="iconsContainer">
            <StyledGearButton
              size={24}
              disabled={location.pathname === '/settings'}
              onClick={() => {
                if (location.pathname === '/settings') return;

                history.push('/settings');
              }}
            />
          </div>
        </StyledHeaderCDropdownItem>

        {status === requestSuccess(GET_NOTIFICATIONS) && filteredNotifications.length > 0 ? (
          <>
            <NotificationContainer>
              <TabContent>
                <NotificationsList
                  data={filteredNotifications.filter(
                    (item) => {
                      if (item.type_id === NOTIFICATION_TYPES.PASSWORD_CHANGE) return false;
                      if (isLeakDetectorNotification(item.type_id)) {
                        return shouldShowLeakDetectors;
                      }
                      return item.type_id != 1 || item.type_id != 6;
                    }
                  )}
                />
              </TabContent>
            </NotificationContainer>

            {location.pathname !== '/notifications' && (
              <StyledNoNoNotificationsButton to="/notifications">
                {t('View All Notifications')}
              </StyledNoNoNotificationsButton>
            )}
          </>
        ) : [requestFail(GET_NOTIFICATIONS), requestFail(REGISTER_FCM_TOKEN)].includes(status) 
          ? <ErrorText>{t('Failed to get notifications.')}</ErrorText> 
          : <LoadingAvatar color={LOADING_BLUE} /> 
        }
      </CDropdownMenu>
    </StyledCDropdown>
  );
};

const StyledCDropdown = styled(CDropdown)`
  .dropdown-menu {
    min-width: 343px;
    border-radius: 30px;
    padding: 24px !important;
  }
`;

// Tabs
export const TabList = styled.div`
  display: flex;
  padding-bottom: 24px;
`;

export const Tab = styled.button`
  padding: 8px 16px;
  border: none;
  background-color: transparent;
  border-bottom: 3px solid ${(props) => (props.isActive ? Palette.OCEANIC_HOVER : 'transparent')};
  &:focus {
    outline: none;
  }
`;

const StyledNoNoNotificationsButton = styled(Link)`
  display: flex;
  justify-content: center;
  color: ${Palette.CUSTOM_GRAY};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  :hover {
    cursor: pointer;
    color: ${Palette.CUSTOM_GRAY};
  }
`;

export const StyledTabLabel = styled.span`
  color: ${Palette.BLACK};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;
const Content = styled.div`
  padding: 0 !important;
  margin: 0 !important;
`;

const TabContent = ({ children }) => <Content>{children}</Content>;

//--------------------------------------------

const StyledHeaderCDropdownItem = styled.div`
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  padding-bottom: 28px !important;

  .title {
    padding: 0 !important;
    margin: 0 !important;
    color: ${Palette.BLACK};
    font-family: ${Fonts.OPEN_SANS_FONT};
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
  }

  .iconsContainer {
    display: flex;
    gap: 6px;

    .configHeaderIcon {
      color: ${Palette.BLACK_50};
      width: 30px;
      height: 30px;
    }
  }
`;

// Styled CDropdownItem
const StyledCDropdownItem = styled(CDropdownItem)`
  cursor: default;
  padding: 0 !important;
  margin: 0 !important;

  padding-top: 8px !important;

  &:active,
  &:focus {
    background: none !important;
    color: #455164;
  }

  strong.viewAllMsgs {
    cursor: pointer;
  }
`;

// Notification Div and Empty Notification Container
const NotificationDiv = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 440px;
  margin-bottom: 15px;
  // background-color: red;

  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 10px;
    background-color: none;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }

  .unread {
    //background: rgba(43, 79, 124, 0.08) !important;
  }
`;

const StyledGearButton = styled(IoMdSettings)`
  :hover {
    color: ${(props) => (props.disabled ? 'inherit' : Palette.BORDER_OUTLINE)} !important;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')} !important;
  }
`;

const StyledMessageContainer = styled.div`
  max-width: 295px;
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  gap: 15px;

  :hover {
    cursor: pointer;
  }

  .messageImage {
    max-width: 48px;
    max-height: 48px;
    border-radius: 10px;
  }

  .messageColumn {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .messageDesc {
    white-space: normal;
    color: ${Palette.BLACK};
    font-family: ${Fonts.OPEN_SANS_FONT};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .messageDate {
    white-space: normal;
    color: ${Palette.RUSTY_ORANGE};
    font-family: ${Fonts.OPEN_SANS_FONT};
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
  }

  .arrowIcon {
    min-width: 15px;
    max-width: 15px;
    min-height: 15px;
    max-height: 15px;
  }
`;

const StyledViewMoreCDropdownItem = styled(CDropdownItem)`
  .viewAllNotif {
    margin: 0 auto;

    color: ${Palette.CUSTOM_GRAY};
    font-family: ${Fonts.OPEN_SANS_FONT};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;

const EmptyNotificationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .empty-notification-text {
    margin: 1em 0;
  }
`;

const NotificationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 !important;
  margin: 0 !important;
`;

export default TheHeaderDropdownMssg;
